export enum SectionItemType {
  Product = 'product',
  Brand = 'brand',
  Collection = 'collection',
}
